export default {
    one_payment: 'Paiement unique',
    weekly: 'Hebdomadaire',
    two_weeks: '2 semaines',
    bi_monthly: 'Bimensuel',
    monthly: 'Mensuel',
};
